import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface ISiteAdminProfileAssignment {
  siteId: string;
  adminProfileLuid: string | null;
}

export interface ISetUserAdminProfileBySitesParams {
  userId: string;
  assignments: ISiteAdminProfileAssignment[];
}

export interface ISetUserAdminProfileBySitesResult extends IResult {}

export class SetUserAdminProfileBySitesRequest extends Request<ISetUserAdminProfileBySitesParams, ISetUserAdminProfileBySitesResult> {
  constructor(params: ISetUserAdminProfileBySitesParams) {
    super('setUserAdminProfileBySites', params);
  }
}
